import { render } from "./HausStep11c.vue?vue&type=template&id=79fcda20"
import script from "./HausStep11c.vue?vue&type=script&lang=js"
export * from "./HausStep11c.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__